<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form class="mt-4" v-if="editar" v-on:submit.prevent="traerDatosPaciente">
      <b-row>
        <b-col>
          <label for="idPaciente">Id de paciente: *</label>
          <b-form-input
           id="idPaciente"
            v-model.number="idPaciente"
            maxLength="14"
            pattern="[0-9]{1,}"
            :state="idPaciente != null"
            required
          >
          </b-form-input>
          <b-form-invalid-feedback :state="idPaciente != null">
            Debe colocar el id
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="text-left">
          <b-button type="submit" class="mt-4" variant="outline-primary">
            Buscar
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <div class="noAlTope" v-if="cargando">
      <b-button variant="primary" disabled>
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>
    </div>

    <div class="mt-4" v-else>
      <b-form v-on:submit.prevent="enviarPaciente">
        <b-row class="text-left">
          <b-col sm="12" md="6" lg="4" xl="4">
            <label for="nombrePaciente"> Nombre(s): *</label>
            <b-form-input
              v-model="formulario.nombre"
              id="nombrePaciente"
              placeholder="Nombre"
              minlength="3"
              :state="formulario.nombre !== '' && formulario.nombre.length > 2"
              required
            ></b-form-input>
            <b-form-invalid-feedback v-if="!formulario.nombre !== ''">
              Se debe colocar el/los nombre(s)
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-else>
              Debes escribir al menos 3 caracteres.
            </b-form-invalid-feedback>
          </b-col>
          <b-col sm="12" md="6" lg="4" xl="4">
            <label for="apellidoPaterno"> Apellido paterno: *</label>
            <b-form-input
              id="apellidoPaterno"
              v-model="formulario.aPaterno"
              placeholder="Apellido paterno"
              minlength="3"
              :state="formulario.aPaterno !== '' && formulario.aPaterno.length > 2"
              required
            ></b-form-input>
            <b-form-invalid-feedback v-if="!formulario.aPaterno !== ''">
              Se debe colocar el apellido paterno
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-else>
              Debes escribir al menos 3 caracteres.
            </b-form-invalid-feedback>
          </b-col>
          <b-col sm="12" md="6" lg="4" xl="4">
            <label for="apellidoMaterno"> Apellido materno: *</label>
            <b-form-input
              id="apellidoMaterno"
              v-model="formulario.aMaterno"
              placeholder="Apellido materno"
              minlength="3"
              :state="formulario.aMaterno !== '' && formulario.aMaterno.length > 2"
              required
            ></b-form-input>
            <b-form-invalid-feedback v-if="!formulario.aMaterno !== ''">
              Se debe colocar el apellido materno
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-else>
              Debes escribir al menos 3 caracteres.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row class="mt-4 mb-4 text-left">
          <b-col sm="12" md="6" lg="4" xl="4">
            <label for="fechaNacimiento"> Fecha de nacimiento: *</label>
            <b-row>
              <b-col>
                <b-form-datepicker
                  v-model="formulario.fechaNac"
                  :state="formulario.fechaNac != null"
                  :max="hoy"
                  required
                  placeholder="Selecciona una fecha"
                  id="fechaNacimiento"
                  no-flip
                  :show-decade-nav="true"
                  @input="edadTutorMaxima($event)"
                >
                </b-form-datepicker>
              </b-col>
            </b-row>
            <b-form-invalid-feedback :state="formulario.fechaNac != null">
              Se debe seleccionar la fecha de nacimiento
            </b-form-invalid-feedback>
          </b-col>
          <b-col sm="12" md="12" lg="4" xl="4">
            <b-row>
              <b-col>
                <label for="sexo"> Sexo: *</label>
                <b-form-select
                  id="sexo"
                  v-model="formulario.sexo"
                  :options="sexoLista"
                  value-field="id"
                  text-field="nombre"
                  :state="formulario.sexo != null"
                  required
                >
                </b-form-select>
                <b-form-invalid-feedback :state="formulario.sexo != null">
                  Se debe seleccionar el sexo
                </b-form-invalid-feedback>
              </b-col>
              <b-col>
                <label for="estadoCivil">Estado civil: *</label>
                <b-form-select
                  v-model="formulario.civil"
                  :options="civil"
                  value-field="id"
                  text-field="descripcion"
                  required
                  :state="formulario.civil != null"
                  id="estadoCivil"
                ></b-form-select>
                <b-form-invalid-feedback :state="formulario.civil != null">
                  Se debe seleccionar una opción
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            sm="12"
            md="6"
            lg="4"
            xl="4"
            v-if="$localStorageService.can('PA_01_datos_px')"
          >
            <label for="ocupacion">Ocupación: </label>
            <b-form-select
              id="ocupacion"
              v-model="formulario.ocupacion"
              :options="ocupaciones"
              value-field="id"
              text-field="descripcion"
            ></b-form-select>
          </b-col>
          <b-col v-else>
            <label for="ocupacion">Ocupación: *</label>
            <b-form-select
              v-model="formulario.ocupacion"
              :options="ocupaciones"
              value-field="id"
              text-field="descripcion"
              :state="formulario.ocupacion != null"
              id="ocupacion"
            ></b-form-select>
            <b-form-invalid-feedback :state="formulario.ocupacion != null">
              Se debe seleccionar una opción
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row class="mb-4 text-left">
          <b-col sm="12" md="12" lg="3" xl="3">
            <label for="extranjero">¿Es Extranjero?</label>
            <validacion />
            <b-form-group>
              <v-select
                style="width: 100%"
                :clearable="false"
                :options="listaSINO"
                v-model="formulario.esExtranjero"
                :reduce="(variable) => variable.valor"
                label="etiqueta"
                placeholder="¿El paciente es extranjero?"
                id="extranjero"
              >
                <span slot="no-options">No hay valores disponibles</span>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="12" lg="3" xl="3" class="align-self-center">
            <b-button
              block
              class="align-center"
              @click="agregarContacto"
              variant="outline-success"
            >
              Agregar Contacto
            </b-button>
          </b-col>
          <b-col sm="12" md="12" lg="3" xl="3" class="align-self-center">
            <b-button
              class="align-center"
              block
              variant="outline-success"
              v-if="!activarDomicilio"
              @click="validarDomicilio()"
              >Agregar Domicilio</b-button
            >
            <b-button
              class="align-center"
              block
              variant="outline-danger"
              v-else
              @click="validarDomicilio()"
              >Eliminar Domicilio</b-button
            >
          </b-col>
        </b-row>
        <b-row style="text-align: center; justify-content: center">
          <b-col cols="10">
            <b-table
              v-if="listaContactos.length > 0"
              id="contactos"
              thead-tr-class="columnas"
              :items="listaContactos"
              :fields="encabezadosContacto"
              responsive
            >
              <template v-slot:cell(medioContacto)="row">
                <b-form-select
                  style="width: auto"
                  v-model="row.item.idMedioContacto"
                  :options="contacto"
                  value-field="idMedioContacto"
                  text-field="descripcion"
                  :state="row.item.idMedioContacto != null"
                  required
                  :disabled="row.item.idMedioContactoPaciente !== null"
                  @input="validarPreferente(row.item)"
                ></b-form-select>
              </template>

              <template
                v-slot:cell(contacto)="row"
                v-if="listaContactos.length > 0"
              >
                <b-form-input
                  v-if="row.item.idMedioContacto === 3"
                  type="email"
                  v-model="row.item.contacto"
                  placeholder="Correo: "
                  max="5"
                  :state="row.item.contacto != null"
                ></b-form-input>

                <b-form-input
                  v-else-if=" row.item.idMedioContacto === 5 || row.item.idMedioContacto === 6 || row.item.idMedioContacto === 7"
                  type="text"
                  v-model="row.item.contacto"
                  placeholder="Red social "
                  max="100"
                  :state="row.item.contacto != null"
                ></b-form-input>

                <VuePhoneNumberInput
                  v-if="row.item.idMedioContacto !== 3 && row.item.idMedioContacto !== 5
                          && row.item.idMedioContacto !== 6 && row.item.idMedioContacto !== 7"
                  v-model="row.item.contacto"
                  maxlength="13"
                  default-country-code="MX"
                  :translations="traslationsTxt"
                  placeholder="Ingresa número a 10 dígitos: *"
                  :state="row.item.contacto != null"
                />
              </template>

              <template v-slot:cell(preferente)="row">
                <b-form-checkbox
                  v-model="row.item.preferente"
                  switch
                  @input="validarPreferente(row.item)"
                >
                </b-form-checkbox>
              </template>

              <template v-slot:cell(accion)="row">
                <b-button
                  variant="outline-danger"
                  v-if="row.item.idMedioContactoPaciente === null"
                  @click="eliminarContacto(row.item)"
                >
                  <b-icon icon="trash" aria-hidden="true"></b-icon>
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>

        <div v-if="activarDomicilio">
          <b-row>
            <b-col>
              <h3>Domicilio</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6" lg="3" xl="3">
              <label for="codigoPostal"> Código postal: *</label>
              <b-form-input
                id="codigoPostal"
                type="number"
                v-model="domicilio.codigoPostal"
                placeholder="Código Postal"
                @keyup="bucarPorCp()"
                required
              ></b-form-input>
            </b-col>
            <b-col sm="12" md="6" lg="3" xl="3">
              <label for="estado"> Estado:</label>
              <b-form-input
                id="estado"
                disabled
                v-model="domicilio.estado"
                placeholder="Estado"
                required
              ></b-form-input>
            </b-col>
            <b-col sm="12" md="6" lg="3" xl="3">
              <label for="municipio">Municipio:</label>
              <b-form-input
                id="municipio"
                disabled
                v-model="domicilio.municipio"
                placeholder="Municipio"
                required
              ></b-form-input>
            </b-col>
            <b-col sm="12" md="6" lg="3" xl="3">
              <label for="localidad">Localidad :</label>
              <v-select
                style="width: 100%"
                label="nombreLocalidad"
                v-model="localidad"
                id="localidad"
                :options="localidades"
                @input="cambioLocalidad($event)"
              ></v-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6" lg="3" xl="3">
              <label for="colonia"> Colonia: *</label>
              <b-form-input
                id="colonia"
                v-model="domicilio.colonia"
                placeholder="Colonia"
                required
              ></b-form-input>
            </b-col>
            <b-col sm="12" md="6" lg="3" xl="3">
              <label for="calle"> Calle: *</label>
              <b-form-input
                id="calle"
                v-model="domicilio.calle"
                placeholder="Calle"
                required
              ></b-form-input>
            </b-col>
            <b-col sm="12" md="6" lg="3" xl="3">
              <label for="numeroExterior"> N° Exterior: *</label>
              <b-form-input
                id="numeroExterior"
                v-model="domicilio.noExterior"
                placeholder="N° Exterior"
                required
              ></b-form-input>
            </b-col>
            <b-col sm="12" md="6" lg="3" xl="3">
              <label for="numeroInterior"> N° Interior: </label>
              <b-form-input
                id="numeroInterior"
                v-model="domicilio.noInterior"
                placeholder="N° Interior"
              ></b-form-input>
            </b-col>
          </b-row>
          <br />
        </div>

        <b-row class="mb-4 text-left" v-if="!historiaNino">
          <b-col sm="12" md="6" lg="3" xl="3">
            <label for="pacientes">Asignar Padre o Tutor registrado en Dentalia:</label>
            <v-select
              label="nombre"
              id="pacientes"
              v-model="paciente"
              :options="listaBusquedaPaciente"
              @input="seleccinarPaciente($event)"
              @search="getBuscarPacienteServicio"
            >
              <template #option="{ nombre, codigoColor }">
                <label for="codigoColor" :style="`color: ${codigoColor}`">{{ nombre }}</label>
              </template>
              <span slot="no-options">No hay datos...</span>
            </v-select>
          </b-col>

          <b-col sm="12" md="6" lg="3" xl="3">
            <label for="parentesco">Parentesco:</label>
            <b-form-select
              id="parentesco"
              v-model="formulario.idParentesco"
              :options="listaParentesco"
              value-field="idParentesco"
              text-field="nombre"
              :state="
                (paciente != null && formulario.idParentesco != null) ||
                paciente == null
              "
            ></b-form-select>
            <b-form-invalid-feedback
              :state="
                (paciente != null && formulario.idParentesco != null) ||
                paciente == null
              "
            >
              Se debe seleccionar un parentesco con el familiar
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <div style="margin-top:5%">
          <b-button  type="submit" variant="outline-primary" v-if="!enviando"
          >Guardar
        </b-button>
        <b-button variant="primary" v-show="enviando" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
        </div>
      </b-form>
      <div style="height: 50px">

      </div>
    </div>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
/* import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css"; */

export default {
  name: "AltaPaciente",
  components: {
    VuePhoneNumberInput,
    /* DatePicker, */
  },
  props: {
    editar: Boolean,
    historiaNino: Boolean,
    ninoLinkProp: Boolean,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    time1: null,
    time2: null,
    time3: null,
    urlBase: null,
    idPaciente: null,
    sexoLista: [],
    ocupaciones: [],
    civil: [],
    contacto: [],
    formulario: {
      idPersona: null,
      aPaterno: "",
      aMaterno: "",
      nombre: "",
      fechaNac: null,
      sexo: null,
      ocupacion: null,
      civil: null,
      contacto: null,
      correo: null,
      telefono: null,
      casa: null,
      trabajo: null,
      esExtranjero: false,
      finComercial:false,
      nuevo: null,
      idpacientePadre: null,
      idParentesco: null,
      claveTelTrabajo: null,
      claveTelCasa: null,
      claveTelCelular: null,
      idPaciente: null,
      idCanalOrigen: null,
      esPacienteVIP:false
    },
    domicilio: {
      idDomicilio: null,
      codigoPostal: null,
      calle: null,
      noExterior: null,
      noInterior: null,
      colonia: null,
      localidad: null,
      municipio: null,
      estado: null,
    },
    activarDomicilio: false,
    estadoNacimiento: null,
    cargando: true,
    enviando: false,
    listaSINO: [
      { etiqueta: "SI", valor: true },
      { etiqueta: "NO", valor: false },
    ],
    paciente: null,
    listaBusquedaPaciente: [],
    listaParentesco: [],
    traslationsTxt: {
      countrySelectorLabel: "Código de país",
      countrySelectorError: "Elige un país",
      phoneNumberLabel: "Número de teléfono",
      example: "Ejemplo :",
    },
    localidades: [],
    localidad: null,
    hoy: new Date(),
    edadPersona: null,
    encabezadosContacto: [
      { key: "medioContacto", label: "Medio" },
      { key: "contacto", label: "Contacto" },
      { key: "preferente", label: "Preferente" },
      { key: "accion", label: "Acción" },
    ],
    listaContactos: [],
    canalesOrigen: []
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.urlBase = this.$api;
    if (this.ninoLinkProp == true) {
      this.urlBase = this.$baseURL + "/";
      this.traerListaSexoHistoria();
      this.traerListaOcupacionHistoria();
      this.traerListaEstadoCivilHistoria();
      this.traerListaContactoHistoria();
      this.obtenerParentescosHistoria();
    } else {
      this.traerListaSexo();
      this.traerListaOcupacion();
      this.traerListaEstadoCivil();
      this.traerListaContacto();
      this.obtenerParentescos();
    }

    this.cargando = false;
  },

  methods: {
    traerDatosPaciente() {
      this.cargando = true;
      const params = {
        idPaciente: this.idPaciente
      }
      let urlPaciente =
        this.$api +
        "paciente/perfiles/obtenerPerfilBasico" ;

      this.$http
        .post(urlPaciente, params)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data == null) {
              this.$swal({
                icon: "error",
                text: "Paciente consultado no existe",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            } else {
              this.formulario.idPersona = response.data.data.idPersona;
              this.formulario.aPaterno = response.data.data.apellidoPaterno;
              this.formulario.aMaterno = response.data.data.apellidoMaterno;
              this.formulario.nombre = response.data.data.nombrePaciente;
              this.formulario.fechaNac = this.$moment(
                response.data.data.fechaNacimiento
              )
                .utc()
                .format("YYYY-MM-DD");
              this.formulario.sexo = response.data.data.sexo;
              this.formulario.ocupacion = response.data.data.ocupacion;
              this.formulario.civil = response.data.data.civil;
              this.formulario.contacto = response.data.data.contacto;
              this.formulario.correo = response.data.data.correo;
              this.formulario.telefono = response.data.data.telefono;
              this.formulario.claveTelCelular =
                response.data.data.claveTelCelular;
              this.formulario.casa = response.data.data.casa;
              this.formulario.claveTelCasa = response.data.data.claveTelCasa;
              this.formulario.trabajo = response.data.data.trabajo;
              this.formulario.claveTelTrabajo =
                response.data.data.claveTelTrabajo;
              this.formulario.esExtranjero = response.data.data.esExtranjero;
              this.formulario.finComercial = response.data.data.finComercial;

              this.paciente = response.data.data.pacientePadre.nombre;
              this.formulario.idpacientePadre =
                response.data.data.idpacientePadre;
              this.formulario.idParentesco = response.data.data.idParentesco;
              this.domicilio =
                response.data.data.domicilio != null
                  ? response.data.data.domicilio
                  : this.domicilio;
              this.listaContactos = response.data.data.contactos;
              this.formulario.idPaciente = response.data.data.idPaciente;

              this.activarDomicilio = response.data.data.domicilio != null;
              this.edadTutorMaxima(this.formulario.fechaNac);

              this.formulario.esPacienteVIP = response.data.data.esPacienteVIP;
            }
          }
        })
        .catch((err) => {
          this.showErroMsg(err);
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    traerListaSexo() {
      let supper = this;
      let urlSexo = this.$api + "catalogos/listaSexo";
      this.$http
        .post(urlSexo)
        .then(function (response) {
          if (response.data.data) {
            response.data.data.unshift({ id: null, nombre: "Sexo:" });
            supper.sexoLista = response.data.data;
          }
        })
        .catch(function (err) {
          supper.showErrorMsg(err);
        });
    },
    traerListaSexoHistoria() {
      let supper = this;
      let urlSexo = this.urlBase + "paciente/catalogo/listaSexo";
      this.$http
        .get(urlSexo)
        .then(function (response) {
          if (response.data.data) {
            response.data.data.unshift({ id: null, nombre: "Sexo:" });
            supper.sexoLista = response.data.data;
          }
        })
        .catch(function (err) {
          supper.showErrorMsg(err);
        });
    },
    traerListaOcupacion() {
      const urlOcupacion = this.$api + "catalogos/listaOcupacion";
      this.$http
        .get(urlOcupacion)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({ id: null, descripcion: "Ocupación:" });
            this.ocupaciones = response.data.data;
          }
        })
        .catch((err) => {
          this.showErroMsg(err);
        });
    },
    traerListaOcupacionHistoria() {
      const urlOcupacion = this.urlBase + "paciente/catalogo/listaOcupacion";
      this.$http
        .get(urlOcupacion)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({ id: null, descripcion: "Ocupación:" });
            this.ocupaciones = response.data.data;
          }
        })
        .catch((err) => {
          this.showErroMsg(err);
        });
    },
    traerListaEstadoCivil() {
      const urlEstado = this.$api + "catalogos/listaEstadoCivil";
      this.$http
        .get(urlEstado)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              id: null,
              descripcion: "Estado civil:",
            });
            this.civil = response.data.data;
          }
        })
        .catch((err) => {
          this.showErroMsg(err);
        });
    },
    traerListaEstadoCivilHistoria() {
      const urlEstado = this.urlBase + "paciente/catalogo/listaEstadoCivil";
      this.$http
        .get(urlEstado)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              id: null,
              descripcion: "Estado civil:",
            });
            this.civil = response.data.data;
          }
        })
        .catch((err) => {
          this.showErroMsg(err);
        });
    },
    traerListaContacto() {
      const urlContacto = this.$api + "catalogos/listaMediosContacto";
      this.$http
        .get(urlContacto)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              idMedioContacto: null,
              descripcion: "Medio contacto:",
            });
            this.contacto = response.data.data;
          }
        })
        .catch((err) => {
          this.showErroMsg(err);
        });
    },
    traerListaContactoHistoria() {
      const urlContacto =
        this.urlBase + "paciente/catalogo/listaMediosContacto";
      this.$http
        .get(urlContacto)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              idMedioContacto: null,
              descripcion: "Medio contacto:",
            });
            this.contacto = response.data.data;
          }
        })
        .catch((err) => {
          this.showErroMsg(err);
        });
    },
    enviarPaciente() {
      if (this.$localStorageService.can("PA_01_px_medioContact") === false) {
        if (
          this.edadPersona >= 0 &&
          this.edadPersona < 12 &&
          this.paciente == null
        ) {
          this.$swal.fire({
            icon: "info",
            title: "Aviso",
            text: "El paciente es menor de edad, es necesario agregar un tutor",
          });
          return false;
        }
      }
      if (this.validacionMedioContacto() === false) {
        return false;
      }

      if (this.editar) {
        this.editarPaciente();
      } else {
        this.guardarPaciente();
      }
    },
    guardarPaciente() {
      if (!this.historiaNino) {
        this.guardarPacienteNormal();
      } else {
        this.guardarPacienteHistoria();
      }
    },
    guardarPacienteNormal() {
      this.enviando = true;
      let urlPacienteNuevo = this.urlBase + "paciente";
      this.$http
        .post(urlPacienteNuevo, this.traerDatos())
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              title: "Paciente ingresado correctamente",
              html: `El paciente cuenta con el id: <strong> ${response.data.data.idPaciente} </strong>`,
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });

            if (
              this.formulario.idPersona === undefined ||
              this.formulario.idPersona === null ||
              this.formulario.idPersona < 1
            ) {
              this.formulario = {
                idPersona: null,
                aPaterno: "",
                aMaterno: "",
                nombre: "",
                dia: null,
                mes: null,
                anio: null,
                sexo: null,
                ocupacion: null,
                civil: null,
                contacto: null,
                correo: null,
                telefono: null,
                casa: null,
                trabajo: null,
                idpacientePadre: null,
                idParentesco: null,
                claveTelTrabajo: null,
                claveTelCasa: null,
                claveTelCelular: null,
                esPacienteVIP: false,
                finComercial: false
              };
              this.paciente = null;
              this.listaContactos = [];
            }
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.enviando = false;
        });
    },
    guardarPacienteHistoria() {
      this.enviando = true;

      let urlPacienteNuevo = this.urlBase + "paciente";
      this.$http
        .post(urlPacienteNuevo, this.traerDatos())
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              title: "Paciente ingresado correctamente",
              html: `El paciente cuenta con el id: <strong> ${response.data.data.idPaciente} </strong>`,
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });

            if (
              this.formulario.idPersona === undefined ||
              this.formulario.idPersona === null ||
              this.formulario.idPersona < 1
            ) {
              this.formulario = {
                idPersona: null,
                aPaterno: "",
                aMaterno: "",
                nombre: "",
                dia: null,
                mes: null,
                anio: null,
                sexo: null,
                ocupacion: null,
                civil: null,
                contacto: null,
                correo: null,
                telefono: null,
                casa: null,
                trabajo: null,
                idpacientePadre: null,
                idParentesco: null,
                claveTelTrabajo: null,
                claveTelCasa: null,
                claveTelCelular: null,
                esPacienteVIP: false,
                finComercial: false
              };
              this.paciente = null;
              this.listaContactos = [];
            }
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.enviando = false;
        });
    },
    editarPaciente() {
      if (
        this.$localStorageService.can("PA_01_datos_px") == false &&
        this.formulario.telefono.length < 7
      ) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "El número telefónico  debe tener mínimo 6 caracteres",
        });
      } else {
        this.enviando = true;
        let urlActualizar = this.$api + "paciente";
        this.$http
          .put(urlActualizar, this.traerDatos())
          .then((response) => {
            if (response.status === 200) {
              this.$swal({
                icon: "success",
                text: "Paciente actualizado correctamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
              this.enviando = false;
            }
          })
          .catch((err) => {
            this.enviando = false;
            this.showErroMsgPost(err);
          });
      }
    },
    traerDatos() {
      let nacimiento = this.formulario.fechaNac;

      let usuario = 0;

      if (!this.ninoLinkProp) {
        usuario = this.$localStorageService.getIdUsuario();
      }

      this.domicilio.localidad =
        this.localidad != null ? this.localidad.nombreLocalidad : null;
      var dia1 = new Date(nacimiento);
      /*dia1.setHours(12, 0, 0, 0);*/
      const fechaNacimiento = this.$moment(dia1)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      return {
        idPersona: this.formulario.idPersona,
        apellidoPaterno: this.$global.limpiarTextoMayus(
          this.formulario.aPaterno
        ),
        apellidoMaterno: this.$global.limpiarTextoMayus(
          this.formulario.aMaterno
        ),
        nombrePaciente: this.$global.limpiarTextoMayus(this.formulario.nombre),
        fechaNacimiento: fechaNacimiento,
        sexo: this.formulario.sexo,
        ocupacion: this.formulario.ocupacion,
        civil: this.formulario.civil,
        contacto: this.formulario.contacto,
        correo: this.formulario.correo,
        telefono: this.formulario.telefono,
        claveTelCelular: this.formulario.claveTelCelular,
        casa: this.formulario.casa,
        claveTelCasa: this.formulario.claveTelCasa,
        trabajo: this.formulario.trabajo,
        claveTelTrabajo: this.formulario.claveTelTrabajo,

        idCompania: 1,
        usuarioLogeado: usuario,
        esExtranjero: this.formulario.esExtranjero,
        finComercial: this.formulario.finComercial,
        idpacientePadre: this.formulario.idpacientePadre,
        idParentesco: this.formulario.idParentesco,
        domicilio: this.domicilio,
        contactos: this.listaContactos,
        idPaciente: this.formulario.idPaciente,
        idClinica: this.$localStorageService.getIdClinica(),
        idCanalOrigen: 1,
        esPacienteVIP: this.formulario.esPacienteVIP
      };
    },
    getBuscarPacienteServicio(search, loading) {
      loading(true);
      clearTimeout(this.controladorTiempo);
      this.controladorTiempo = setTimeout(() => {
        const params = {
          nombrePaciente: search
        }
        this.$http
          .post(
            this.$api +
              "paciente/perfiles/obtenerpacientes/activos", params )
          .then((response) => {
            if (response.data.data) {
              this.listaBusquedaPaciente = [];
              let resultado = response.data.data;
              resultado.forEach((item, index) => {
                item.id = index;
                this.listaBusquedaPaciente.push(item);
              });
              loading(false);
            }
          })
          .catch(function (error) {
            console.error(error);
            loading(false);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          });
        clearTimeout(this.controladorTiempo);
      }, 1000);
    },
    /**
     * Obtener el select del paciente
     * @param paciente
     */
    seleccinarPaciente(paciente) {
      if (paciente == null) {
        this.formulario.idParentesco = null;
        this.formulario.idpacientePadre = null;
      } else {
        this.formulario.idpacientePadre = paciente.idPaciente;
      }
    },

    obtenerParentescos() {
      this.$http
        .get(this.$api + "paciente/catalogo/listaParentesco")
        .then((respuesta) => {
          if (respuesta.data.data) {
            respuesta.data.data.forEach((it) => {
              this.listaParentesco.push(it);
            });
          }
        });
    },
    obtenerParentescosHistoria() {
      this.$http
        .get(this.urlBase + "paciente/catalogo/listaParentesco")
        .then((respuesta) => {
          if (respuesta.data.data) {
            respuesta.data.data.forEach((it) => {
              this.listaParentesco.push(it);
            });
          }
        });
    },

    onUpdateTelPersonal(payload) {
      if (payload.countryCallingCode != undefined) {
        this.formulario.claveTelCelular = payload.countryCallingCode;
      }
    },

    onUpdateTelCasa(payload) {
      if (payload.countryCallingCode != undefined) {
        this.formulario.claveTelCasa = payload.countryCallingCode;
      }
    },

    onUpdateTeltrabajo(payload) {
      if (payload.countryCallingCode != undefined) {
        this.formulario.claveTelTrabajo = payload.countryCallingCode;
      }
    },
    validarDomicilio() {
      this.activarDomicilio = !this.activarDomicilio;
      this.domicilio.activo = this.activarDomicilio;
    },
    bucarPorCp() {
      const params = {
        codigoPostal: this.domicilio.codigoPostal
      }

      if (this.domicilio.codigoPostal.length === 5) {
        let url = "localidad/postales";
        /*if (this.ninoLinkProp == true) {
          url = "paciente/postales?codigo=";
        }*/
        this.$http
          .post(this.urlBase + url, params)
          .then((response) => {
            if (response.data.data) {
              response.data.data;
              this.localidades = response.data.data;
              if (this.localidades.length > 0) {
                this.localidad = this.localidades[0];
                this.domicilio.colonia = this.localidades[0].nombreLocalidad;
                this.domicilio.municipio = this.localidades[0].nombreMunicipio;
                this.domicilio.estado = this.localidades[0].nombreEstado;
              }
            }
          });
      }
    },
    cambioLocalidad(item) {
      this.domicilio.colonia = item.nombreLocalidad;
      this.domicilio.municipio = item.nombreMunicipio;
      this.domicilio.estado = item.nombreEstado;
    },
    edadTutorMaxima(evento) {
      const fechaActual = this.$moment();
      this.edadPersona = fechaActual.diff(evento, "years");
    },
    agregarContacto() {
      this.listaContactos.push({
        idMedioContactoPaciente: null,
        idMedioContacto: null,
        contacto: null,
        preferente: null,
      });
    },
    validarPreferente(item) {
      if (item.preferente === true) {
        var filtrados = this.listaContactos.filter(
          (c) =>
            c.idMedioContacto === item.idMedioContacto && c.preferente === true
        );
        if (filtrados.length > 1) {
          this.$swal({
            icon: "warning",
            text: "No puedes tener dos contactos preferentes del mismo tipo.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          }).then(() => {
            item.preferente = false;
          });
        }
      }
    },

    eliminarContacto(item) {
      let index = this.listaContactos.indexOf(item);
      this.listaContactos.splice(index, 1);
    },
    validacionMedioContacto() {
      let validado = true;
      let celular = this.listaContactos.filter((c) => c.idMedioContacto === 2);
      if (
        celular.length === 0 &&
        this.$localStorageService.can("PA_01_px_medioContact") === false
      ) {
        this.$swal({
          icon: "warning",
          text: "Debes ingresar un contacto de tipo Celular.",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        validado = false;
      }
      if (celular.length > 0) {
        let celularPreferente = this.listaContactos.filter(
          (c) => c.idMedioContacto === 2 && c.preferente === true
        );
        if (celularPreferente.length === 0) {
          this.$swal({
            icon: "warning",
            text: "Debes seleccionar un Celular como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
        if (celularPreferente.length > 1) {
          this.$swal({
            icon: "warning",
            text: "No puedes tener dos celulares como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
      }

      let correo = this.listaContactos.filter((c) => c.idMedioContacto === 3);

      if (
        correo.length === 0 &&
        this.$localStorageService.can("PA_01_px_medioContact") === false
      ) {
        this.$swal({
          icon: "warning",
          text: "Debes ingresar un contacto de tipo Correo.",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        validado = false;
      }

      if (
        this.listaContactos.filter((c) => c.idMedioContacto === 1).length !== 0
      ) {
        if (
          this.listaContactos.filter(
            (c) => c.idMedioContacto === 1 && c.preferente === true
          ).length === 0
        ) {
          this.$swal({
            icon: "warning",
            text: "Debes seleccionar un Teléfono de casa como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
        if (
          this.listaContactos.filter(
            (c) => c.idMedioContacto === 1 && c.preferente === true
          ).length > 1
        ) {
          this.$swal({
            icon: "warning",
            text: "No puedes tener dos teléfonos de casa como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
      }

      if (
        this.listaContactos.filter((c) => c.idMedioContacto === 2).length !== 0
      ) {
        if (
          this.listaContactos.filter(
            (c) => c.idMedioContacto === 2 && c.preferente === true
          ).length === 0
        ) {
          this.$swal({
            icon: "warning",
            text: "Debes seleccionar un celular como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
        if (
          this.listaContactos.filter(
            (c) => c.idMedioContacto === 2 && c.preferente === true
          ).length > 1
        ) {
          this.$swal({
            icon: "warning",
            text: "No puedes tener más de un celular como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
      }

      if (
        this.listaContactos.filter((c) => c.idMedioContacto === 3).length !== 0
      ) {
        if (
          this.listaContactos.filter(
            (c) => c.idMedioContacto === 3 && c.preferente === true
          ).length === 0
        ) {
          this.$swal({
            icon: "warning",
            text: "Debes seleccionar un Correo como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
        if (
          this.listaContactos.filter(
            (c) => c.idMedioContacto === 3 && c.preferente === true
          ).length > 1
        ) {
          this.$swal({
            icon: "warning",
            text: "No puedes tener más de un correo como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
      }

      if (
        this.listaContactos.filter((c) => c.idMedioContacto === 4).length !== 0
      ) {
        if (
          this.listaContactos.filter(
            (c) => c.idMedioContacto === 4 && c.preferente === true
          ).length === 0
        ) {
          this.$swal({
            icon: "warning",
            text: "Debes seleccionar un Teléfono de Trabajo como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
        if (
          this.listaContactos.filter(
            (c) => c.idMedioContacto === 4 && c.preferente === true
          ).length > 1
        ) {
          this.$swal({
            icon: "warning",
            text: "No puedes tener más de un teléfono de trabajo como preferente.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          validado = false;
        }
      }
      return validado;
    },
  },
  notifications: {
    showErroMsg: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    showErroMsgPost: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al insertar la información",
    },
  },
};
</script>

<style></style>
